/* eslint-disable @typescript-eslint/no-unused-vars */
import { LibraryIssue } from '../../../../../common/interfaces/Issue'
import { filterIssues } from '../../utils/issueUtils'
import { descendingSort } from '../../utils/sort'
import Carousel from 'react-multi-carousel'
import dayjs from 'dayjs'
import styles from './styles'
import { IssuesProps } from './type'
import {
  REMOVE_ARROW_ON_SMALL_IMAGE_DEVICE,
  responsiveSmall
} from '../../constants'
import useWindowSize from '../../hooks/useWindowResize'
import SkeletonIssueCard from '../skeleton/SkeletonIssueCard'
import ScrollIndicator from '../carousel/ScrollIndicator'

interface OpenIssueProps extends IssuesProps {
  currentOpenIssue?: LibraryIssue
}

const OpenIssues = (props: OpenIssueProps) => {
  const { isLandscape } = useWindowSize()
  const { issues, title, startDate, endDate, onClick, currentOpenIssue } = props
  const openIssues = filterIssues(issues, title, startDate, endDate)
  let recentOpenIssues = descendingSort(
    openIssues.filter((i) => i.lastOpenedAt),
    'lastOpenedAt'
  )
  if (recentOpenIssues.length > 0) {
    const entitlementIds = recentOpenIssues.map(
      (issue: LibraryIssue) => issue.entitlementId
    )
    if (entitlementIds.includes(currentOpenIssue?.entitlementId)) {
      const excludeCurrentOpenIssues = recentOpenIssues.filter(
        (issue: LibraryIssue) =>
          issue.entitlementId !== currentOpenIssue?.entitlementId
      )
      recentOpenIssues = [currentOpenIssue, ...excludeCurrentOpenIssues]
    } else {
      recentOpenIssues = currentOpenIssue
        ? [currentOpenIssue, ...recentOpenIssues]
        : recentOpenIssues
    }
  }

  return recentOpenIssues.length > 0 ? (
    <div key={title} style={{ marginBottom: 40 }}>
      <div
        style={{
          ...styles.title,
          fontSize: 24,
          fontWeight: 600,
          marginBottom: 20
        }}
        className={'section-label'}
      >
        Continue Reading ({recentOpenIssues.length})
      </div>
      <div className="carousel-container">
        <Carousel
          ssr
          deviceType={'desktop'}
          responsive={responsiveSmall(isLandscape)}
          removeArrowOnDeviceType={REMOVE_ARROW_ON_SMALL_IMAGE_DEVICE}
          partialVisible
        >
          {recentOpenIssues.map((i: LibraryIssue) => {
            const { coverImageUrl, magTitle, issueDate, entitlementId = '' } = i
            return (
              <div
                style={{
                  height: '100%',
                  padding: '0 8px',
                  cursor: 'pointer'
                }}
                key={coverImageUrl}
                className="issue-card-small"
              >
                <div
                  className={'small-image-container'}
                  style={{
                    borderRadius: 12,
                    overflow: 'hidden',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                    marginBottom: 10,
                    padding: '12px',
                    transition:
                      'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <img
                    draggable={false}
                    key={coverImageUrl}
                    style={{ ...styles.productImageSmall, borderRadius: 0 }}
                    src={coverImageUrl}
                    alt={magTitle}
                    onClick={() => onClick(entitlementId)}
                  />
                </div>
                <div
                  className={'title'}
                  style={{ fontSize: 16, fontWeight: 500, marginBottom: 4 }}
                >
                  {magTitle}
                </div>
                <div
                  className={'description'}
                  style={{ color: '#666', fontSize: 13 }}
                >
                  {dayjs(issueDate).format('MMMM D, YYYY')}
                </div>
              </div>
            )
          })}
        </Carousel>
        <ScrollIndicator
          show={window.innerWidth <= 768 && recentOpenIssues.length > 1}
        />
      </div>
    </div>
  ) : null
}

export default OpenIssues
